import React from 'react';
import '../footer/footer.css';
import '../../App.css';
import fbImg from '../../images/s-icon1.svg';
import twImg from '../../images/s-icon2.svg';
import indImg from '../../images/s-icon3.svg';
// import indImg from '../../images/s-icon4.svg';
import footerLogo from '../../images/carter-logo.svg';

function UserFooter() {
  return (
    <footer>
        <p>
            © {new Date().getFullYear()} Carter Capner Law. All Rights Reserved.<br />
            This portal is for registered participants only. The information contained herein is confidential.{' '}
            <a href="/privacy" className="link">Privacy Policy</a>.
        </p>
    </footer>
  );
}

export default UserFooter;
